/* global axios */
import AsteriskApiClient from './index';

class QueueRoutesAPI extends AsteriskApiClient {
  constructor() {
    super('queue_routes');
  }

  // GET /api/v1/accounts/:account_id/asterisk/queue_routes
  get() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:account_id/asterisk/queue_routes/:id
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/asterisk/queue_routes
  create(data) {
    return axios.post(this.url, { queue_route: data });
  }

  // PUT /api/v1/accounts/:account_id/asterisk/queue_routes/:id
  update(id, data) {
    return axios.put(`${this.url}/${id}`, { queue_route: data });
  }

  // DELETE /api/v1/accounts/:account_id/asterisk/queue_routes/:id
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new QueueRoutesAPI();
